// Plan ▸ Shape: the book scene by scene — length, point of view, sentence length, dialogue and vocabulary on one axis.
export { ShapePage as component, ShapeControls as headerControls } from '../../views/story/ShapePage.tsx';
export { StoryColumn as column } from '../../views/story/StoryColumn.tsx';
export const room = 'plan';
export const page = 'shape';
export const title = 'Shape';
export const help = 'shape';
export const columnTitle = 'People';
